import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {RefundRequestDgSearchResults} from "../models/datagrid-search-results/refund-request.dg-search-results.model";
import {RefundRequestsService} from "../providers/refund-requests.service";

@Injectable()
export class RefundRequestResolve implements Resolve<RefundRequestDgSearchResults> {
  constructor(private refundRequestsService: RefundRequestsService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<RefundRequestDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.refundRequestsService.getResults(20, 0, 'DESC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
